import { StatusChipTone } from 'uiComponents/statusChip/statusChip'
import { TimeSlotGroupStatus } from './timeSlotsService'

// One tone per status, shared by every surface that shows a time slot group: upcoming is information, not a warning.
export const TIME_SLOT_STATUS_TONE: Record<TimeSlotGroupStatus, StatusChipTone> = {
    active: 'success',
    upcoming: 'info',
    expired: 'neutral',
}
